module.exports = __webpack_public_path__ + "img/11-l.4d7fed7b.png";